// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.feeder-container {
  margin: 0 auto;
  margin-top: -30px;
  max-width: 1800px;
  padding: 20px 9px;
  width: 90%;
}

.feeder-tab-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 16px;
  position: relative;
}
.feeder-tab-container .feeder-tab {
  border-radius: 10px 10px 0 0;
  background-color: white;
  border-color: #808080 #808080 #0669B3 #808080;
  border-style: solid;
  border-width: 1px 1px 2px 1px;
  bottom: -12px;
  color: #636161;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-weight: 600;
  height: 50px;
  margin-right: 10px;
  min-width: 25%;
  padding: 10px 10px 5px 15px;
  position: relative;
}
.feeder-tab-container .feeder-tab .current-address {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FEBF31;
  color: black;
  border-radius: 8px 8px 0px 0px;
  box-sizing: content-box;
  font-size: 0.8rem;
  height: 14px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.feeder-tab-container .feeder-tab .feeder-tab-contents {
  color: #065b9d;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 5px;
  width: 100%;
}
.feeder-tab-container .feeder-tab .feeder-tab-contents .selected-count {
  display: flex;
  flex-direction: row;
  font-size: 0.6rem;
  margin-top: 5px;
}
.feeder-tab-container .feeder-tab .feeder-tab-contents .selected-count .tab-circle {
  border-radius: 50px;
  background-color: #636161;
  color: white;
  font-size: 0.84rem;
  height: 20px;
  width: 20px;
  white-space: nowrap;
}
.feeder-tab-container .feeder-tab .feeder-tab-contents .selected-count .active-circle {
  background-color: #0669B3;
  color: white;
}
.feeder-tab-container .feeder-tab .feeder-tab-contents .selected-count span {
  margin-left: 3px;
  margin-top: 2px;
}
.feeder-tab-container .active-feeder {
  background-color: #D1D3D4;
  border-color: #0669B3 #0669B3 #D1D3D4 #0669B3;
  border-width: 2px;
  bottom: -2px;
  color: #19608f;
  height: 60px;
  padding-top: 14px;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/FeederTabs.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;AAUJ;;AARA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;AAWJ;AATI;ECdA,4BDe0B;EACtB,uBAAA;EACA,6CAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,cDDA;ECEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;AAWR;AATQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBDtBA;ECuBA,YAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAWZ;AARQ;EACI,cDzBI;EC0BJ,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;AAUZ;AARY;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAUhB;AARgB;EC9DZ,mBD+DsC;EACtB,yBD5CZ;EC6CY,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAUpB;AAPgB;EACI,yBDnDP;ECoDO,YAAA;AASpB;AANgB;EACI,gBAAA;EACA,eAAA;AAQpB;AAHI;EACI,yBDrEA;ECsEA,6CAAA;EACA,iBAAA;EACA,YAAA;EACA,cDpFE;ECqFF,YAAA;EACA,iBAAA;EACA,YAAA;AAKR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"./global/Colors\";\n@import \"./global/globalMixins.scss\";\n\n.feeder-container {\n    margin: 0 auto;\n    margin-top: -30px;\n    max-width: 1800px;\n    padding: 20px 9px;\n    width: 90%;\n}\n.feeder-tab-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    margin-left: 16px;\n    position: relative;\n\n    .feeder-tab {\n        @include borderRadius(10px 10px 0 0);\n        background-color: white;\n        border-color: $grey3 $grey3 $pearl-blue $grey3;\n        border-style: solid;\n        border-width: 1px 1px 2px 1px;\n        bottom: -12px;\n        color: $grey4;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        font-weight: 600;\n        height: 50px;\n        margin-right: 10px;\n        min-width: 25%;\n        padding: 10px 10px 5px 15px;\n        position: relative;\n\n        .current-address {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: $important;\n            color: black;\n            border-radius: 8px 8px 0px 0px;\n            box-sizing: content-box;\n            font-size: 0.8rem;\n            height: 14px;\n            left: 0;\n            position: absolute;\n            top: 0;\n            width: 100%;\n        }\n\n        .feeder-tab-contents {\n            color: $dk-pearl-blue;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            margin-top: 5px;\n            width: 100%;\n\n            .selected-count {\n                display: flex;\n                flex-direction: row;\n                font-size: 0.6rem;\n                margin-top: 5px;\n\n                .tab-circle {\n                    @include borderRadius(50px);\n                    background-color: $grey4;\n                    color: white;\n                    font-size: 0.84rem;\n                    height: 20px;\n                    width: 20px;\n                    white-space: nowrap;\n                }\n\n                .active-circle {\n                    background-color: $pearl-blue;\n                    color: white;\n                }\n\n                span {\n                    margin-left: 3px;\n                    margin-top: 2px;\n                }\n            }\n        }\n    }\n    .active-feeder {\n        background-color: $grey1;\n        border-color: $pearl-blue $pearl-blue $grey1 $pearl-blue;\n        border-width: 2px;\n        bottom: -2px;\n        color: $dk-blue;\n        height: 60px;\n        padding-top: 14px;\n        z-index: 999;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
